module.exports = __webpack_public_path__ + "img/cloud-bolt.964c0a30.svg";